import { Card, Modal } from "pepsico-ds";
import "./TermsAndConditionsModal.scss";

function TermAndConditionModal({
  termAndConditionModalOpen,
  toggleTCModal,
  tcData,
}) {
  return (
    <Modal
      className="termAndConditionModal"
      showModal={termAndConditionModalOpen}
      onCloseModal={toggleTCModal}
      title={"Terms & Conditions"}
      primaryButtonProps={{
        size: "medium",
        text: "Back",
        variant: "primary",
        onClick: () => {
          toggleTCModal();
        },
      }}
      showSecondaryButton={false}
      showTertiaryButton={false}
      showLink={false}
    >
      <Card>
        <div dangerouslySetInnerHTML={{ __html: tcData }} />
      </Card>
    </Modal>
  );
}

export default TermAndConditionModal;
